<script setup lang="ts">
import type { Link } from '~~/types'

defineProps<{
  title: string
  links: Link[]
  to?: string
}>()
</script>

<template>
  <div class="flex flex-col gap-1.5">
    <NuxtLink
      v-if="to"
      :to="to"
      class="text-sm font-semibold text-highlighted mb-0.5 hover:text-primary transition-colors"
    >
      {{ title }}
    </NuxtLink>
    <h3
      v-else
      class="text-sm font-semibold text-highlighted mb-0.5"
    >
      {{ title }}
    </h3>
    <ul class="space-y-1.5">
      <li
        v-for="link in links"
        :key="link.to"
      >
        <NuxtLink
          :to="link.to"
          class="text-sm text-muted hover:text-highlighted transition-colors"
        >
          {{ link.label }}
        </NuxtLink>
      </li>
    </ul>
  </div>
</template>
